/* eslint-disable no-unused-vars */
/* global $clamp, config */

// Gestion des appels ajax
const $get = (url) => {
	return new Promise((resolve, reject) => {
		const req = new XMLHttpRequest();

		req.onload = () => {
			if (req.readyState === 4 && req.status === 200)
				resolve(JSON.parse(req.response));
			else {
				console.error(`Oups, ça march'te pas 😕 [${url}]`);
				// eslint-disable-next-line prefer-promise-reject-errors
				reject();
			}
		};

		req.open('GET', url);
		req.send();
	});
};

/**
 * @description Chargement de script js dynamique
 * source : https://webdevdesigner.com/q/jquery-getscript-alternative-in-native-javascript-95131/
 * @param source
 * @param beforeEl
 * @param async
 * @param defer
 * @returns {Promise<unknown>}
 */
const loadScript = (source, beforeEl, async = true, defer = true) => {
	return new Promise((resolve, reject) => {
		let script = document.createElement('script');
		const prior = beforeEl || document.getElementsByTagName('script')[0];

		script.async = async;
		script.defer = defer;

		function onloadHander(_, isAbort) {
			if (
				isAbort ||
				!script.readyState ||
				/loaded|complete/.test(script.readyState)
			) {
				script.onload = null;
				script.onreadystatechange = null;
				script = undefined;

				if (isAbort) {
					// eslint-disable-next-line prefer-promise-reject-errors
					reject();
				} else {
					resolve();
				}
			}
		}

		script.onload = onloadHander;
		script.onreadystatechange = onloadHander;

		script.src = source;
		prior.parentNode.insertBefore(script, prior);
	});
};

// Toggle
const $toggle = (element, type) => {
	const el = element;
	const { display } = el.ownerDocument.defaultView.getComputedStyle(el, null);

	if (display !== 'none') el.style.display = 'none';
	else el.style.display = type;
};

// A11Y Swiper
const a11y = () => {
	// a11y items duplicate
	const tabindex = -1;
	document.querySelectorAll('li.swiper-slide-duplicate > a').forEach((el) => {
		el.setAttribute('tabindex', tabindex);
	});
	document.querySelectorAll('.swiper-slide-duplicate').forEach((el) => {
		el.setAttribute('aria-hidden', 'true');
		el.classList.add('disabled');
		el.removeAttribute('data-swiper-slide-index');
	});
	// a11y items not:duplicate
	const tabIndex = 0;
	document
		.querySelectorAll('li.swiper-slide:not(.swiper-slide-duplicate) > a')
		.forEach((el) => {
			el.setAttribute('tabindex', tabIndex);
		});
	document
		.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
		.forEach((el) => {
			el.setAttribute('aria-hidden', 'false');
			el.removeAttribute('data-swiper-slide-index');
		});
};

// Hide Nav/Swiper
const navSlide = () => {
	const nbSlide = document.querySelectorAll('.swiper-slide').length;
	if (nbSlide <= 2) {
		document.querySelectorAll('.swiper-nav').forEach((nav) => {
			nav.remove();
		});

		document.querySelectorAll('.swiper-wrapper').forEach((wrapper) => {
			wrapper.style.paddingLeft = 0;
		});
	}
};

const polyfillsIE = () => {
	if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
		// Polyfill forEach ES5
		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = function (callback, thisArg) {
				thisArg = thisArg || window;
				for (let i = 0; i < this.length; i++) {
					callback.call(thisArg, this[i], i, this);
				}
			};
		}
	}
};

const activeDot = () => {
	// FONCTIONS
	// Lancement de la librairie clamp sur chaque éléments dotdot @see https://github.com/josephschmitt/Clamp.js
	const dotdot = () => {
		document.querySelectorAll('[data-dot]').forEach((element) => {
			const lines = element.getAttribute('data-dot');
			$clamp(element, { clamp: lines });
		});
	};

	const dotP = ($content, $lines) => {
		document.querySelectorAll($content).forEach((element) => {
			element.setAttribute('data-dot', $lines);
		});
		document.querySelectorAll(`${$content}> p`).forEach((element) => {
			element.setAttribute('data-dot', $lines);
		});
		document.querySelectorAll(`${$content}> span`).forEach((element) => {
			element.setAttribute('data-dot', $lines);
		});
	};

	// EVENTS
	const events = () => {
		const obs = new MutationObserver(() => {
			dotdot();
		});

		obs.observe(config.root, {
			childList: true,
		});
	};

	// GO 🚀
	const init = () => {
		dotP('div.card-text', '4');
		dotP('div.gallery', '3');
		dotP('div.rt__grid__result__item h3', '2');
		dotdot();
		events();
	};

	init();
};

/**
 *
 * @param {Element} root la modal
 * @param {Element} lastFocusableElement Paramètre optionnel, permet de cibler un element en particulier pour lequel le focus reviendra au début
 * @description Naviguer au clavier dans la modal
 */
const keyboardNavigation = (root, lastFocusableElement = null) => {
	const focusableElements =
		'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	const firstFocusableElement = root.querySelectorAll(focusableElements)[0];
	const focusableContent = root.querySelectorAll(focusableElements);
	if (!lastFocusableElement) {
		lastFocusableElement = focusableContent[focusableContent.length - 1];
	}

	document.addEventListener('keydown', function (e) {
		const isTabPressed = e.key === 'Tab';

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			// if shift key pressed for shift + tab combination
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus(); // add focus for the last focusable element
				e.preventDefault();
			}
		} else {
			// if tab key is pressed
			if (document.activeElement === lastFocusableElement) {
				// if focused has reached to last focusable element then focus first focusable element after pressing tab
				firstFocusableElement.focus(); // add focus for the first focusable element
				e.preventDefault();
			}
		}
	});

	firstFocusableElement.focus();
};

function isTouchDevice() {
	return true === ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
